import React from 'react';
import { Tooltip } from '@mui/material';
import { goalDataTypeEnums, graphValueModeEnums } from 'utils';

// The choices each data type offers; other data types have nothing to choose, so the toggle is hidden.
const MODE_OPTIONS = {
    [goalDataTypeEnums.DURATION]: {
        info: 'Total: the sum of a session’s trial durations. Average: the mean duration of a trial in the session.',
        options: [
            { value: graphValueModeEnums.DEFAULT, label: 'Total' },
            { value: graphValueModeEnums.AVERAGE, label: 'Average' },
        ],
    },
    [goalDataTypeEnums.PERCENT]: {
        info:
            'All trials: % of correct trials in the session. First trial: 100% when the session’s first response is correct, ' +
            'else 0% — grouped data shows the % of sessions with a correct first response.',
        options: [
            { value: graphValueModeEnums.DEFAULT, label: 'All trials' },
            { value: graphValueModeEnums.FIRST_TRIAL, label: 'First trial' },
        ],
    },
};

/** "Show: [Total | Average]" for DURATION goals, "Show: [All trials | First trial]" for PERCENT goals. */
export const GraphValueModeToggle = ({ dataType, value, onChange }) => {
    const config = MODE_OPTIONS[dataType];
    if (!config) return null;

    return (
        <Tooltip title={config.info} arrow>
            <div className="insights-value-mode">
                <span className="insights-value-mode-label">Show</span>
                <div className="insights-display-toggle">
                    {config.options.map((option) => (
                        <button
                            key={option.value}
                            className={`insights-display-btn ${(value || graphValueModeEnums.DEFAULT) === option.value ? 'active' : ''}`}
                            onClick={() => onChange(option.value)}
                        >
                            {option.label}
                        </button>
                    ))}
                </div>
            </div>
        </Tooltip>
    );
};

/** Request param for the drilldown: only sent when a non-default mode applies to the goal's data type. */
export const toValueModeParam = (dataType, valueMode) =>
    MODE_OPTIONS[dataType] && valueMode && valueMode !== graphValueModeEnums.DEFAULT ? valueMode : undefined;
